export { BucketsPage } from '@pages/admin/buckets-page/ui/BucketsPage';
